var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      attrs: {
        editTitle: "Portal-Feld bearbeiten",
        createTitle: "Neues Portal-Feld hinzufügen",
      },
    },
    [
      _c("table", [
        _c("tr", [
          _c("th", { staticClass: "is-top" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Ebene:")]),
          ]),
          _vm._v(" "),
          _c("td", [
            _c(
              "div",
              { staticClass: "control" },
              [
                _c("multiselect", {
                  staticClass: "is-shorter",
                  attrs: {
                    options: _vm.entityTypeOptions,
                    label: "value",
                    "track-by": "key",
                    "allow-empty": false,
                    disabled: _vm.editMode,
                  },
                  model: {
                    value: _vm.entityType,
                    callback: function ($$v) {
                      _vm.entityType = $$v
                    },
                    expression: "entityType",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.form.entityType === "passenger"
          ? _c("tr", [
              _c("th", { staticClass: "is-top" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Feldart:")]),
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "control" },
                  [
                    _c("multiselect", {
                      staticClass: "is-shorter",
                      attrs: {
                        options: _vm.fieldKindOptions,
                        label: "value",
                        "track-by": "key",
                        "allow-empty": false,
                        disabled: _vm.editMode,
                      },
                      model: {
                        value: _vm.fieldKind,
                        callback: function ($$v) {
                          _vm.fieldKind = $$v
                        },
                        expression: "fieldKind",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "help" }, [
                  _vm._v(
                    "Standardfeld = vorhandenes Teilnehmer-Feld (Vorname, Nachname …). Eigenes Feld = zusätzliches Custom-Feld."
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.form.source === "entity"
          ? _c("tr", [
              _c("th", { staticClass: "is-top" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Standardfeld:"),
                ]),
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "control" },
                  [
                    _c("multiselect", {
                      staticClass: "is-shorter",
                      attrs: {
                        options: _vm.entityFieldOptions,
                        label: "label",
                        "track-by": "key",
                        "allow-empty": false,
                        placeholder: "Feld wählen",
                      },
                      model: {
                        value: _vm.standardField,
                        callback: function ($$v) {
                          _vm.standardField = $$v
                        },
                        expression: "standardField",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.form.source !== "entity"
          ? _c("tr", [
              _c("th", { staticClass: "is-top" }, [
                _c(
                  "label",
                  { staticClass: "label", attrs: { for: "fieldKey" } },
                  [_vm._v("Key:")]
                ),
              ]),
              _vm._v(" "),
              _c("td", [
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.fieldKey,
                        expression: "form.fieldKey",
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      type: "text",
                      id: "fieldKey",
                      disabled: _vm.editMode,
                      placeholder: "z.B. tShirtSize",
                    },
                    domProps: { value: _vm.form.fieldKey },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form, "fieldKey", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "help" }, [
                  _vm._v(
                    "Nur Buchstaben/Ziffern/Unterstriche, beginnt mit Buchstabe. Nach dem Anlegen nicht mehr änderbar."
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("tr", [
          _c("th", { staticClass: "is-top" }, [
            _c("label", { staticClass: "label", attrs: { for: "label" } }, [
              _vm._v("Label:"),
            ]),
          ]),
          _vm._v(" "),
          _c("td", [
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.label,
                    expression: "form.label",
                  },
                ],
                staticClass: "input",
                attrs: { type: "text", id: "label" },
                domProps: { value: _vm.form.label },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "label", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.form.source !== "entity"
          ? _c("tr", [
              _c("th", { staticClass: "is-top" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Typ:")]),
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "control" },
                  [
                    _c("multiselect", {
                      staticClass: "is-shorter",
                      attrs: {
                        options: _vm.typeOptions,
                        label: "value",
                        "track-by": "key",
                        "allow-empty": false,
                      },
                      model: {
                        value: _vm.type,
                        callback: function ($$v) {
                          _vm.type = $$v
                        },
                        expression: "type",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        ["select", "checkboxes"].includes(_vm.form.type) &&
        _vm.form.source !== "entity"
          ? _c("tr", [
              _c("th", { staticClass: "is-top" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Auswahloptionen:"),
                ]),
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "control" },
                  [
                    _c("multiselect", {
                      attrs: {
                        options: _vm.form.options || [],
                        multiple: true,
                        taggable: true,
                        "tag-placeholder": "Option hinzufügen",
                        placeholder: "Option eintippen und Enter",
                      },
                      on: { tag: _vm.addOption },
                      model: {
                        value: _vm.form.options,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "options", $$v)
                        },
                        expression: "form.options",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.form.source !== "entity"
          ? _c("tr", [
              _c("th", { staticClass: "is-top" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Quelle:")]),
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "control" },
                  [
                    _c("multiselect", {
                      staticClass: "is-shorter",
                      attrs: {
                        options: _vm.sourceOptions,
                        label: "value",
                        "track-by": "key",
                        "allow-empty": false,
                      },
                      model: {
                        value: _vm.source,
                        callback: function ($$v) {
                          _vm.source = $$v
                        },
                        expression: "source",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.form.source === "computed"
          ? _c("tr", [
              _c("th", { staticClass: "is-top" }, [
                _c(
                  "label",
                  { staticClass: "label", attrs: { for: "resolverKey" } },
                  [_vm._v("Resolver-Key:")]
                ),
              ]),
              _vm._v(" "),
              _c("td", [
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.resolverKey,
                        expression: "form.resolverKey",
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      type: "text",
                      id: "resolverKey",
                      placeholder: "z.B. roomStats.fix_total",
                    },
                    domProps: { value: _vm.form.resolverKey },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form, "resolverKey", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "help" }, [
                  _vm._v(
                    "Muss zu einem PortalFieldResolver im Code passen — ohne Resolver bleibt das Feld leer."
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("tr", [
          _c("th", { staticClass: "is-top" }, [
            _c("label", { staticClass: "label", attrs: { for: "sortOrder" } }, [
              _vm._v("Reihenfolge:"),
            ]),
          ]),
          _vm._v(" "),
          _c("td", [
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.form.sortOrder,
                    expression: "form.sortOrder",
                    modifiers: { number: true },
                  },
                ],
                staticClass: "input",
                attrs: { type: "number", id: "sortOrder" },
                domProps: { value: _vm.form.sortOrder },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "sortOrder", _vm._n($event.target.value))
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "help" }, [
              _vm._v(
                "Bestimmt die Spaltenposition (10er-Schritte; Teilnehmer-Felder werden mit den Standardfeldern verzahnt)."
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.form.entityType === "order"
          ? _c("tr", [
              _c("th", { staticClass: "is-top" }, [
                _c("label", { staticClass: "label", attrs: { for: "width" } }, [
                  _vm._v("Spaltenbreite (px):"),
                ]),
              ]),
              _vm._v(" "),
              _c("td", [
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.form.width,
                        expression: "form.width",
                        modifiers: { number: true },
                      },
                    ],
                    staticClass: "input",
                    attrs: { type: "number", id: "width" },
                    domProps: { value: _vm.form.width },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form, "width", _vm._n($event.target.value))
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.form.source === "manual" || _vm.form.source === "entity"
          ? _c("tr", [
              _c("th", { staticClass: "is-top" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Im Portal editierbar:"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c(
                    "toggle-switch",
                    {
                      model: {
                        value: _vm.form.editable,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "editable", $$v)
                        },
                        expression: "form.editable",
                      },
                    },
                    [
                      _c("option", { domProps: { value: true } }, [
                        _vm._v("Ja"),
                      ]),
                      _vm._v(" "),
                      _c("option", { domProps: { value: false } }, [
                        _vm._v("Nein"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "help" }, [
                    _vm._v(
                      "Nein = der Kunde sieht den Wert nur; gepflegt wird er von uns."
                    ),
                  ]),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("tr", [
          _c("th", { staticClass: "is-top" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Aktiv:")]),
          ]),
          _vm._v(" "),
          _c(
            "td",
            [
              _c(
                "toggle-switch",
                {
                  model: {
                    value: _vm.form.active,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "active", $$v)
                    },
                    expression: "form.active",
                  },
                },
                [
                  _c("option", { domProps: { value: true } }, [_vm._v("Ja")]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: false } }, [
                    _vm._v("Nein"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }